import { makeStyles } from '@material-ui/core/styles';
import {
  CARD_HEIGHT,
  DEFAULT_METRIC_COLOR,
  ICON_MARGIN_RIGHT,
  FONT_SIZE_LARGE,
  MARGIN_TOP
} from '../constants/primitive-metrics.constants';

export const useMetricCardStyles = makeStyles((theme) => ({
  card: {
    cursor: 'pointer',
    transition: 'transform 0.2s',
    height: CARD_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  headerIcon: {
    marginRight: ICON_MARGIN_RIGHT,
  },
  activeIcon: {
    color: DEFAULT_METRIC_COLOR,
    marginRight: ICON_MARGIN_RIGHT,
  },
  headerTitle: {
    fontWeight: 'bold',
    fontSize: FONT_SIZE_LARGE,
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  previewMetrics: {
    flex: 1,
    overflow: 'hidden',
  },
  viewMoreLink: {
    fontWeight: 'bold',
    marginTop: MARGIN_TOP,
  },
}));
